export const LOGIN = 'LOGIN';
export const SCORE = 'SCORE';
